import 'firebase/compat/remote-config'
import 'firebase/compat/messaging'
import {initializeApp} from 'firebase/app'

import {getMessaging, getToken} from 'firebase/messaging'
import {getRemoteConfig, fetchAndActivate, getValue, getAll} from 'firebase/remote-config'

import {configuration} from '../../configuration'

export default {

    remoteConfig: {},

    remoteData: {},

    proxy: {},

    messagingToken: '',

    messaging: {},

    firebaseApp: {},

    init: async function () {
        // REMOTE-CONFIG
        this.proxy = new Proxy(this.remoteData, {})

        const firebaseConfig = configuration.firebaseConfig

        this.firebaseApp = initializeApp(firebaseConfig)

        const remoteConfig = getRemoteConfig(this.firebaseApp)

        remoteConfig.settings.minimumFetchIntervalMillis = 3600000
        remoteConfig.settings.fetchTimeoutMillis = 60000
        remoteConfig.defaultConfig = {}

        fetchAndActivate(remoteConfig)
            .then((fetchedRemotely) => {
                this.remoteConfigFetchedRemotely = fetchedRemotely
                this.proxy.data = getAll(remoteConfig)
            })
            .catch(() => {
            })

        this.remoteConfig = remoteConfig

        // MESSAGING

        this.messaging = getMessaging(this.firebaseApp)
        await getToken(this.messaging, {vapidKey: configuration.firebaseConfig.cloudMessagingCertificat})
            .then((currentToken) => {
                if (currentToken) {
                    this.messagingToken = currentToken
                }
            }).catch(() => {})
    },


    async getValue(key, type) {

        return await new Promise(resolve => {

            if (this.remoteConfigFetchedRemotely === undefined) {
                this.loopGetValue(key, type, resolve)
            } else {
                const value = getValue(this.remoteConfig, key)
                resolve(this.extractData(value['_value'], type))
            }
        })

    },

    loopGetValue(key, type, resolve) {
        setTimeout(() => {
            resolve(this.getValue(key, type))
        }, 10)
    },

    extractData(data, type) {
        if (data) {
            switch (type) {
                case this.TYPES.NUMBER:
                    return parseInt(data, 10)
                case this.TYPES.BOOLEAN:
                    return data === 'true'
                case this.TYPES.OBJECT:
                    return JSON.parse(data)
                default:
                    return data
            }
        }
    },

    TYPES: {
        STRING: 'String',
        NUMBER: 'Number',
        BOOLEAN: 'Boolean',
        OBJECT: 'Object'
    },

    KEYS: {
        LANDING_WITHOUT_QR_CODE  : 'landing_without_qr_code_web',
        EVENT_UI: 'event_ui',
        IS_USER_FROM_USA: 'is_user_from_usa'
    }
}
